'use client';

import { FC, useState, useEffect } from 'react';
import { useParams, useRouter } from 'next/navigation';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ButtonBase from '@mui/material/ButtonBase';
import { Box, Grid, Paper, Stack, Container, Typography } from '@mui/material';

import Image from '../../../../components/image';
import { useLocales } from '../../../../locales';
import Iconify from '../../../../components/iconify';
import { useAuthContext } from '../../../../auth/hooks';
import { getCustomer } from '../../../../api/citypeople';
import { getVirtualCardsByCustomerId } from '../../../../api/clubCards';
import { ActionTypes, useAppContext } from '../../../../contexts/AppContext';
import { BlockType, ComponentTypeProps } from '../../../../types/page-generator';

const CryptoCardOverview: FC<ComponentTypeProps> = ({ block }) => {
  const localParams = useParams();
  const router = useRouter();
  const [currency, setCurrency] = useState('USD');
  const { currentLang } = useLocales();
  const { dispatch, state } = useAppContext();
  const { user } = useAuthContext();
  const cryptoWalletLink: any = block?.cryptoWalletLink;
  const cardsLink: any = block?.cardsLink;

  useEffect(() => {
    if (user?.id) {
      getCustomer(user.id, dispatch);
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (state.customer?.id) {
      getVirtualCardsByCustomerId(state.customer.id).then((cards) => {
        if (Array.isArray(cards)) {
          dispatch({
            type: ActionTypes.GET_VIRTUAL_CARD,
            payload: cards,
          });
        }
      });
    }
  }, [state.customer, dispatch]);

  const balances: any = {
    USD: '97.02',
    EUR: '89.56',
    BTC: '0.0023',
    ETH: '0.0341',
  };

  const mockCards = [
    {
      id: 1,
      image: '/assets/images/small-wallet.png',
      name: '0.93 USD',
      info: 'Crypto Wallet',
      status: 'Approved',
      link: cryptoWalletLink,
    },
    {
      id: 2,
      image: '/assets/images/small-card.png',
      name: '91.14 USD',
      info: 'Cards',
      status: 'Canceled',
      link: cardsLink,
    },
  ];

  const myCards = state.virtualCards?.length
    ? state.virtualCards.map((card: any) => ({
        id: card.id,
        image: card.cardType?.mainImageURL || '/assets/images/small-wallet.png',
        name: `${card.balance} USD`,
        info: card.cardType?.name || 'Crypto Wallet',
        status: card.status || 'Approved',
        link: card.isGlobal ? cryptoWalletLink : cardsLink,
      }))
    : mockCards;

  const firstStop = block?.settings?.firstGradientColorStop
    ? `${block?.settings?.firstGradientColorStop}%`
    : '40%';
  const secondStop = block?.settings?.secondGradientColorStop
    ? `${block?.settings?.secondGradientColorStop}%`
    : '100%';

  const colorGradient = block?.settings?.addGradientStyle
    ? `linear-gradient(90deg, ${block?.settings?.firstGradientColor} ${firstStop}, ${block?.settings?.secondGradientColor} ${secondStop} )`
    : '';

  const firstButtonStop = block?.settings?.firstButtonGradientColorStop
    ? `${block?.settings?.firstButtonGradientColorStop}%`
    : '40%';
  const secondButtonStop = block?.settings?.secondButtonGradientColorStop
    ? `${block?.settings?.secondButtonGradientColorStop}%`
    : '100%';

  const colorButtonGradient = block?.settings?.addButtonGradientStyle
    ? `linear-gradient(90deg, ${block?.settings?.firstButtonGradientColor} ${firstButtonStop}, ${block?.settings?.secondButtonGradientColor} ${secondButtonStop} )`
    : '';

  return (
    <Container maxWidth="sm" sx={{ p: 0 }}>
      {block?.settings?.enableGreetings && (
        <Typography
          sx={{
            textAlign: currentLang.value === 'he' ? 'end' : 'start',
          }}
        >
          Good Afternoon!
        </Typography>
      )}
      {block?.settings?.enableGreetings && (
        <Typography
          variant="h4"
          sx={{
            textAlign: currentLang.value === 'he' ? 'end' : 'start',
          }}
        >
          {state.customer?.firstName
            ? `${state.customer.firstName} ${state.customer.lastName || ''}`
            : 'Harel Gobani'}
        </Typography>
      )}
      {block?.settings?.enableCard && (
        // <Box
        //   sx={{
        //     border: '1px dashed white',
        //     borderRadius: '20px',
        //     position: 'relative',
        //     pt: 10,
        //     display: 'flex',
        //     alignItems: 'center',
        //     justifyContent: 'center',
        //     height: 150,
        //     background: block?.settings?.waveColor || '#3F3456',
        //   }}
        // >
        <Box
          sx={{
            width: '100%',
            borderRadius: 3,
            p: 3,
            color: 'white',
            background: block?.settings?.addGradientStyle
              ? colorGradient
              : block?.settings?.cardColor || '#F55D52',
            boxShadow: 6,
            // mt: -25,
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {/* <Box */}
          {/*  sx={{ */}
          {/*    position: 'absolute', */}
          {/*    top: -20, */}
          {/*    right: -20, */}
          {/*    width: 120, */}
          {/*    height: 120, */}
          {/*    borderRadius: '50%', */}
          {/*    backgroundColor: 'rgba(255,255,255,0.15)', */}
          {/*  }} */}
          {/* /> */}
          {/* <Box */}
          {/*  sx={{ */}
          {/*    position: 'absolute', */}
          {/*    top: -10, */}
          {/*    right: -10, */}
          {/*    width: 80, */}
          {/*    height: 80, */}
          {/*    borderRadius: '50%', */}
          {/*    backgroundColor: 'rgba(255,255,255,0.25)', */}
          {/*  }} */}
          {/* /> */}
          <Stack
            direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
            sx={{
              alignItems: 'center',
              mt: 2,
            }}
          >
            <Typography variant="h4" sx={{ color: 'white' }}>
              {balances[currency]}
            </Typography>
            <Select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              disableUnderline
              variant="standard"
              size="small"
              sx={{
                ml: 2,
                bgcolor: 'transparent',
                color: 'white',
                border: 'none',
                direction: currentLang.value === 'he' ? 'rtl' : 'ltr', // Меняем направление текста и иконки
                '& .MuiSelect-icon': {
                  color: 'white',
                  right: currentLang.value === 'he' ? 'unset' : '4px',
                  left: currentLang.value === 'he' ? '-15px' : 'unset', // Ставим иконку слева при иврите
                },
                '& .MuiInputBase-input': {
                  padding: '6px 24px 6px 6px',
                },
                '&.MuiInputBase-root': {
                  margin: '0px !important',
                },
                '& .MuiSelect-select': {
                  fontSize: '20px',
                  textAlign: currentLang.value === 'he' ? 'right' : 'left', // Чтобы текст красиво вставал
                },
              }}
            >
              {Object.keys(balances).map((code) => (
                <MenuItem value={code} key={code}>
                  {code}
                </MenuItem>
              ))}
            </Select>
          </Stack>

          <Typography
            sx={{
              mb: 2,
              textAlign: currentLang.value === 'he' ? 'end' : 'start',
            }}
          >
            Total Assets
          </Typography>
        </Box>
        // </Box>
      )}
      {block?.settings?.enableButtons && <CardPanel block={block} />}
      {block?.settings?.enableAssets && (
        <Stack
          direction="row"
          alignItems={currentLang.value === 'he' ? 'flex-end' : 'flex-start'}
          justifyContent={currentLang.value === 'he' ? 'flex-end' : 'flex-start'}
        >
          <Typography variant="h6" sx={{ my: 2, color: 'black' }}>
            Assets
          </Typography>
        </Stack>
      )}
      {block?.settings?.enableAssets && (
        <Grid container spacing={2}>
          {myCards.map((card, id) => (
            <Grid item xs={6} key={id}>
              <Stack
                direction={currentLang.value === 'he' ? 'row-reverse' : 'row'}
                width={1}
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  background: block?.settings?.addButtonGradientStyle
                    ? colorButtonGradient
                    : '#2b1d36',
                  borderRadius: '20px',
                  p: 2,
                  py: 4,
                  position: 'relative',
                  cursor: 'pointer',
                }}
                onClick={() => router.push(`/${localParams.lng}/${card?.link}`)}
              >
                <Stack gap={2} alignItems={currentLang.value === 'he' ? 'flex-end' : 'flex-start'}>
                  <Image src={card.image} sx={{ width: '30px' }} />
                  <Stack alignItems={currentLang.value === 'he' ? 'flex-end' : 'flex-start'}>
                    <Typography sx={{ color: 'white', fontWeight: 1000 }}>{card.name}</Typography>
                    <Typography sx={{ color: '#F5F5F5' }}>{card.info}</Typography>
                  </Stack>
                </Stack>
                <Iconify icon="simple-line-icons:arrow-right" sx={{ color: 'white' }} />
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

type Props = {
  block: BlockType;
};

function CardPanel({ block }: Props) {
  const combinedBlock: any = block?.combinedBlock || [];
  const localParams = useParams();
  const router = useRouter();
  const { dispatch, state } = useAppContext();
  const firstStopNavigate = block?.settings?.firstGradientColorStopNavigate
    ? `${block?.settings?.firstGradientColorStopNavigate}%`
    : '40%';
  const secondStopNavigate = block?.settings?.secondGradientColorStopNavigate
    ? `${block?.settings?.secondGradientColorStopNavigate}%`
    : '100%';

  const colorGradientNavigate = block?.settings?.addGradientStyleNavigate
    ? `linear-gradient(90deg, ${block?.settings?.firstGradientColorNavigate} ${firstStopNavigate}, ${block?.settings?.secondGradientColorNavigate} ${secondStopNavigate} )`
    : '';

  const view = (item: any) =>
    block?.settings?.variant === '1' ? (
      <ButtonBase
        sx={{
          borderRadius: '50%',
          overflow: 'hidden',
          display: 'inline-block',
        }}
      >
        <Paper
          elevation={6} // Чем больше — тем выше тень
          sx={{
            backgroundColor: '#fff', // Или другой цвет фона, не 'transparent'
            borderRadius: '50%',
            // border: '1px solid black',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: 80,
            width: 80,
            boxShadow: (theme) => theme.shadows[6], // можно явно указать тень
          }}
        >
          <Iconify
            icon={item.buttonIcon}
            sx={{
              width: 30,
              height: 30,
              color: item.buttonColor || '#FFC107',
            }}
          />
          <Typography
            variant="body1"
            sx={{
              mt: 1,
              color: item.buttonColor || '#FFC107',
              fontSize: item?.buttonFontSize || '12px',
              textAlign: 'center',
            }}
          >
            {item.buttonTitle}
          </Typography>
        </Paper>
      </ButtonBase>
    ) : (
      <Paper
        elevation={6}
        sx={{
          // background: '#2a1e38',
          // backgroundImage: `url('/assets/images/button-font.png')`,
          background: block?.settings?.addGradientStyleNavigate ? colorGradientNavigate : '',
          borderRadius: 3,
          padding: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: 120,
          width: 180,
        }}
      >
        <Iconify
          icon={item.buttonIcon}
          sx={{
            width: '30px',
            height: '30px',
            color: item.buttonColor || '#FFC107',
          }}
        />
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            color: item.buttonColor || '#FFC107',
            fontSize: item?.buttonFontSize || '12px',
            textAlign: 'center',
          }}
        >
          {item.buttonTitle}
        </Typography>
      </Paper>
    );

  const setActiveDialog = (payload: null | string) => {
    dispatch({ type: ActionTypes.SET_ACTIVE_DIALOG, payload });
  };

  return (
    <Stack alignItems="center" mt={2}>
      <Box
        sx={{
          width: block?.settings?.serviceButtonVariant === '2' ? '70%' : '100%',
        }}
      >
        {/* Верхний ряд: 2 карточки */}
        <Grid container spacing={2} justifyContent="center">
          {combinedBlock.map((item: any, index: number) => (
            <Grid
              item
              xs={block?.settings?.serviceButtonVariant === '2' ? 6 : 4}
              key={index}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'center',
              }}
              onClick={() => {
                if (item?.buttonHref && item?.buttonHref !== '#' && !item?.buttonDrawer) {
                  router.push(`/${localParams.lng}/${item?.buttonHref}`);
                }
                if (
                  !item?.buttonHref &&
                  item?.buttonHref === '#' &&
                  item.buttonDrawer &&
                  item.buttonModal
                ) {
                  setActiveDialog(item.buttonModal);
                }
              }}
            >
              {view(item)}
            </Grid>
          ))}
        </Grid>
      </Box>
    </Stack>
  );
}

export default CryptoCardOverview;
